import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#232325] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1: Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p className="text-stone-400 mb-4">
              Daily payments. Your home. Building your legacy, day by day.
            </p>
            <p className="text-stone-400 space-y-1">
              <span className="flex items-center"><MapPin className="w-4 h-4 mr-2 text-[#81be00]" /> Kampala, Uganda</span><br />
              <span className="flex items-center"><Phone className="w-4 h-4 mr-2 text-[#81be00]" /> +256-200-920200 <br /> +256-762-534774 <br /> +256-77 550 8453</span>
              <span className="flex items-center"><Mail className="w-4 h-4 mr-2 text-[#81be00]" /> info@nyinimu.com</span>
            </p>
          </div>

          {/* Column 2: FAQ */}
         <div>
           <h3 className="text-lg font-semibold mb-4">FAQ</h3>
           <ul className="text-stone-400 space-y-2">
             <li><Link to="/faq" className="hover:text-white transition-colors duration-300">How do daily payments work?</Link></li>
             <li><Link to="/faq" className="hover:text-white transition-colors duration-300">Do I need a plot to start?</Link></li>
             <li><Link to="/faq" className="hover:text-white transition-colors duration-300">How long is construction?</Link></li>
             <li><Link to="/faq" className="hover:text-white transition-colors duration-300">When do I become the owner?</Link></li>
           </ul>
         </div>

          {/* Column 3: Useful links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Useful links</h3>
            <ul className="text-stone-400 space-y-2">
              <li><a href="#" className="hover:text-white transition-colors duration-300">News</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">Projects</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">License</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">Terms of service</a></li>
            </ul>
          </div>

          {/* Column 4: Form */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Subscribe</h3>
            <p className="text-stone-400 mb-4">
              Stay updated with our latest news and offers.
            </p>
            <form className="space-y-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-2 bg-transparent text-white border-b border-gray-600 focus:outline-none focus:border-white"
              />
              <button
                type="submit"
                className="w-full bg-[#81be00] text-white py-2 rounded hover:bg-[#6aa000] transition-colors duration-300"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom section with copyright and social media */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-stone-400 text-sm">&copy; 2025 Nyinimu Properties. All rights reserved. Daily payments. Your home.</p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-stone-400 hover:text-white transition-colors duration-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3.67 2h4.71L12.3 7.55 16.02 2h4.3l-6.1 8.58L21 22h-4.72l-3.86-5.65L8.3 22H4l6.21-8.92z"/>
              </svg>
            </a>
            <a href="#" className="text-stone-400 hover:text-white transition-colors duration-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm0 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Zm5 3.5A3.5 3.5 0 1 1 8.5 12 3.5 3.5 0 0 1 12 8.5Zm0 2A1.5 1.5 0 1 0 13.5 12 1.5 1.5 0 0 0 12 10.5Zm4.25-4.75a.75.75 0 1 1-.75.75.75.75 0 0 1 .75-.75Z"/>
              </svg>
            </a>
            <a href="#" className="text-stone-400 hover:text-white transition-colors duration-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
              </svg>
            </a>
            <a href="#" className="text-stone-400 hover:text-white transition-colors duration-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.987C24.007 5.367 18.641.001 12.017.001z"/>
              </svg>
            </a>
            <a href="#" className="text-stone-400 hover:text-white transition-colors duration-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="#" className="text-stone-400 hover:text-white transition-colors duration-300">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.368 0h3.948c.208 1.84 1.463 3.397 3.236 3.97v3.705a7.673 7.673 0 0 1-3.9-1.066v7.6c0 3.64-2.873 6.59-6.418 6.59-3.546 0-6.419-2.95-6.419-6.59 0-3.64 2.873-6.59 6.419-6.59.407 0 .806.038 1.193.11V12.92a2.589 2.589 0 0 0-1.193-.278c-1.43 0-2.59 1.174-2.59 2.622 0 1.447 1.16 2.621 2.59 2.621 1.41 0 2.563-1.148 2.59-2.577V0Z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
